/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Addons_Confirm_Copilot_Remove_DescInputs */



/**
* | output |
* | --- |
* | "Compliance Copilot will remain active until the end of your current billing period. It will not renew on your next invoice." |
*
* @param {Sub_Addons_Confirm_Copilot_Remove_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_addons_confirm_copilot_remove_desc = /** @type {((inputs?: Sub_Addons_Confirm_Copilot_Remove_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Addons_Confirm_Copilot_Remove_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Compliance Copilot bleibt bis zum Ende Ihres aktuellen Abrechnungszeitraums aktiv. Er wird auf Ihrer nächsten Rechnung nicht verlängert.")
	return /** @type {LocalizedString} */ ("Compliance Copilot will remain active until the end of your current billing period. It will not renew on your next invoice.")
});